import { css, cx } from "@emotion/css"
import Options from "components/inputs/Options"
import {
  autoCompleteStyles,
  filterInputStyles,
  standardScrollBar,
} from "../../styles"
import { ReactNode } from "react"

type StyledFilterInputProps = {
  name: string
  label: string
  value: string
  disabled?: boolean
  options: {
    label: ReactNode
    value: string
  }[]
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  inputClass?: string
}

export function StyledFilterInput({
  name,
  label,
  value,
  disabled,
  options,
  onChange,
  inputClass = css`
    background: var(--other-blue);
  `,
}: StyledFilterInputProps) {
  return (
    <Options
      name={name}
      label={label}
      value={value}
      disabled={disabled}
      options={options}
      selectClass={filterInputStyles.filterSelect}
      iconClass={filterInputStyles.filterIcon}
      inputLabelClass={filterInputStyles.filterInputLabel}
      rootClass={filterInputStyles.filterInputRoot}
      inputClass={cx(filterInputStyles.filterInput, inputClass)}
      paperClass={cx(
        standardScrollBar.root,
        filterInputStyles.extrafilterPaper,
        autoCompleteStyles.paper,
      )}
      classes={{
        root: autoCompleteStyles.root,
      }}
      onChange={onChange}
    />
  )
}
